import React from 'react';
import useStyles from "../../partner/style";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

const InputSelectTypeOfOutput = ({ text, setValue, label, isEnable, isRequired }) => {
    const classes = useStyles();

    const handleChange = (e) => {
        const value = e.target.value;
        if (value != '') {
            setValue({ ...text, text: value, valid: 'true' });
        } else {
            setValue({ ...text, text: value, valid: 'false' });
        }
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>
            <FormControl className={classes.formControl}>
                <Select
                    onChange={handleChange}
                    displayEmpty
                    disabled={isEnable ?? false}
                    value={text.text}
                    style={{color:"#FFFFFF"}}
                >
                    <MenuItem value=""> Selecciona </MenuItem>
                    <MenuItem value="traspaso">Traspaso</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
}

export default InputSelectTypeOfOutput;
